import VideoJsAdapter from "@javascripts/adapters/videojs_adapter";
import DomUtils from "@javascripts/utils/dom_utils";
import Image from "./image";
import TimeIndicator from "./time_indicator";
import Component from "../../component";
import PlayerUtil from '@javascripts/utils/player_util'

export default class ThumbnailContainer extends Component {
  constructor(player, options){
    super(player, options);
    this.player().on("ready", function(){
      if(this.options_[0]){
        this.bindThumbnailEvent();
      }
    }.bind(this));
  }

  bindThumbnailEvent(){
    this.bindShowThumbnail();
    this.bindHideThumbnail();
  }

  bindShowThumbnail(){
    let moveHandler = function(moveEvent){
      if (PlayerUtil.isInPipMode()) return

      let activeTime = this.getActiveTime(moveEvent);
      this.updateImageBySecond(activeTime);
      this.adjustSelfLeft(moveEvent);
      this.updateTimeIndicator(moveEvent);
    };

    this.getProgressControlComponent().on("mousemove", moveHandler.bind(this));
    this.getProgressControlComponent().on("touchmove", moveHandler.bind(this))
  }

  bindHideThumbnail(){
    let moveEventCancel = function(){
      this.contentEl().style.left = "-1000px";
    };

    this.getProgressControlComponent().on("mouseout", moveEventCancel.bind(this));
    this.player().on("userinactive", moveEventCancel.bind(this));
  }

  createEl(){
    let contentEl = super.createEl("div", { className: "vjs-thumbnails-container" });
    this._image = new Image();
    this._timeIndicator = new TimeIndicator();

    contentEl.appendChild(this.image().el());
    contentEl.appendChild(this.timeIndicator().el());

    this.setupFirstImage();
    this.setDuration();

    return contentEl;
  }


  image(){
    return this._image;
  }

  timeIndicator(){
    return this._timeIndicator;
  }

  imageEl(){
    return this.image().el();
  }

  timeIndicatorEl(){
    return this.timeIndicator().el();
  }

  setupFirstImage(){
    let options = this.options_;
    if(options !== undefined && options[0] !== undefined){
      this.image().updateSrc(options[0].src);
    }
  }

  setDuration(){
    if(this.player()){
      // when container using HLS
      this.player().on("loadedmetadata", function(){
        this._duration = this.player().duration();
      }.bind(this));

      // for android
      this.player().on("durationchange", function(){
        this._duration = this.player().duration();
      }.bind(this));
    }
  }

  videoDuration(){
    return this._duration;
  }

  updateImageBySecond(second){
    let selectedOption = this.options_[second];
    if(selectedOption && selectedOption.src){
      if(this.imageEl().src !== selectedOption.src){
        this.image().updateSrc(selectedOption.src);
      }
    }
  }

  getProgressControlComponent(){
    if(typeof this._progressControl == "undefined"){
      this._progressControl = this.player().controlBar.progressControl;
    }
    return this._progressControl;
  }

  // moveEvent can be mousemove or touchmove
  getMousePageOffset(moveEvent){
    let progressControlEl, pageXOffset, left, moveEventXLoc;
    progressControlEl = this.getProgressControlComponent().el();
    pageXOffset = DomUtils.getScrollOffset().x;

    //mousemove event get x coordinate
    moveEventXLoc = moveEvent.pageX;

    //touchmove event get x coordinate
    if(moveEvent.changedTouches){
      moveEventXLoc = moveEvent.changedTouches[0].pageX;
    }

    // find the page offset of the mouse
    left = moveEventXLoc || ( moveEvent.clientX + document.body.scrollLeft + document.documentElement.scrollLeft );
    // subtract the page offset of the positioned offset parent
    left -= ( DomUtils.offsetParent(progressControlEl).getBoundingClientRect().left + pageXOffset );
    return left;
  }

  // mouseTime is the position of the mouse along the progress control bar
  // `left` applies to the mouse position relative to the player so we need
  // to remove the progress control's left offset to know the mouse position
  // relative to the progress control
  getMouseTime(moveEvent){
    let left, progressControlComponent, mouseTime;
    left = this.getMousePageOffset(moveEvent);
    progressControlComponent = this.getProgressControlComponent();

    mouseTime = Math.floor( left /  progressControlComponent.width() * this.videoDuration()  );
    return mouseTime;
  }

  getActiveTime(moveEvent){
    let active = 0;
    for(let time in this.options_){
      if(this.getMouseTime(moveEvent) >= time){
        active = Math.max(active, time);
      }
    }
    return active;
  }

  adjustSelfLeft(moveEvent){
    let pageXOffset, progressControlClientRect, left, right, width, halfWidth;
    pageXOffset = DomUtils.getScrollOffset().x;
    progressControlClientRect = DomUtils.offsetParent(this.getProgressControlComponent().el()).getBoundingClientRect();

    left = this.getMousePageOffset(moveEvent);
    right = ( progressControlClientRect.width || progressControlClientRect.right ) + pageXOffset;
    width = DomUtils.getVisibleWidth(this.imageEl());
    halfWidth = width/ 2;

    // make sure that the thumbnail doesn't fall off the right side of the left side of the player
    if( (left + halfWidth) > right ){
      left -= ((left + halfWidth) - right);
    }else if(left < halfWidth){
      left = halfWidth;
    }

    // maxleft is set to progressbar width - 164(thumbnail size) because we dont want thumbnail to go out the player same as minLeft to prevent thumbnail placed out player
    var maxLeft = this.getProgressControlComponent().el().offsetWidth - 164;
    var minLeft = 2;
    left = left - 80;
    if(left < minLeft){
      left = minLeft;
    }
    else if(left > maxLeft){
      left = maxLeft;
    }
    this.contentEl().style.left = left+"px";
  }

  updateTimeIndicator(moveEvent){
    let moveProgressTime, time;
    moveProgressTime = DomUtils.getPointerPosition(this.getProgressControlComponent().el(), moveEvent).x;
    time = VideoJsAdapter.formatTime(moveProgressTime * this.videoDuration());
    this.timeIndicator().updateTime(time);
  }
}

VideoJsAdapter.registerComponent("VpThumbnails", ThumbnailContainer);
